<template>
     <div class="page-content">
		  <script data-n-head="true" type="application/ld+json">{
			  "@context":"http://schema.org",
			  "@type":"BreadcrumbList","itemListElement":[
				  {
					  "@type":"ListItem",
					  "position":1,
					  "item":"https://GameEnable.com/article/","name":"Articles"
				  },
				  {
					  "@type":"ListItem",
					  "position":2,
					  "item":"https://GameEnable.com/article/{{id}}","name":"{{title}}"
				  }
			  ]
		  }</script>
 		<v-card style="margin-top:10px;position: relative;">

			  <v-card-title style="font-size: 26px; " class="text-action">{{title}}</v-card-title>




    <v-card-text class="text--primary" ><br>
   			<p v-html="$t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogContent_1')"></p>
		<br><br>
		<p v-html="$t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogContent_2')"></p>
		<v-col lg="7" md="12" sm="12" style="position: relative; margin: 70px auto;">
			<v-card
					class="mx-auto"

			>
				<iframe height="400"   :src="'https://www.youtube.com/embed/' + videos.PlayDestiny2OnStadiaFromUnsupported" style="width:100%"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>



			</v-card>
		</v-col>


    </v-card-text>

   <v-card-subtitle class="pb-0" >By GameEnable team  •  Decmber 11, 2020  </v-card-subtitle>
		</v-card>


        </div>
</template>

<style>



</style>

<script>

  import i18n from "@/i18n";
  import {mapGetters} from 'vuex';
  import Page from '../../mixins/page'

  export default {
    name: 'how-to-play-destiny-2-on-stadia-without-subscription',
	  mixins: [Page],
	  data: ()=>({
		  id: 'how-to-play-destiny-2-on-stadia-without-subscriptionn'
	  }),
    computed: {
		...mapGetters([
			'videos'
		]),
		pageTitle(){
			return i18n.t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogPageTitle');
		},
		pageDescription(){
			return i18n.t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogPageDescription');
		},
      title() {return i18n.t('blog.PlayDestiny2OnStadiaFromUnsupportedCountryForFreeBlogTitle')}
    }
  };
</script>
